module.exports = __webpack_public_path__ + "img/case1.4016eb69.png";